export enum DataTableTabs {
    ORDERS_AND_POSITIONS,
    EXPOSURE_TRADING_TOOLS,
    HISTORY
}